<script>
  import { Modal } from "svelte-utilities";
  import { api } from "#src/api";
  import TextareaInput from "./TextareaInput.svelte";
  import TextInput from "./TextInput.svelte";

  export const open = (requestId) => openModal(requestId);

  let modal;
  let promptText = "";
  let schema = null;
  let responseText = "";
  let model = "";
  let usage = "";
  let reasoning = "";
  let duration_ms = "";
  let reasoningLevel = "low";

  async function openModal(requestId) {
    modal.open();

    const log = await api.from("llm_request_log").select("*").eq("id", requestId).single();

    if (log.data) {
      promptText = log.data.data.prompt_text;
      responseText =
        typeof log.data.data.response === "string"
          ? log.data.data.response
          : JSON.stringify(log.data.data.response, null, 2);
      model = log.data.model;
      reasoningLevel = log.data.data.reasoning_level;
      reasoning = log.data.data.reasoning;
      duration_ms = log.data.duration_ms;
      usage = log.data.usage ? JSON.stringify(log.data.usage, null, 2) : "";
      if (log.data.data.schema) {
        schema = JSON.stringify(log.data.data.schema, null, 2);
      }
    }
  }
</script>

<Modal bind:this={modal} width="32rem" closeable>
  <div slot="title">LLM Request Info</div>
  <div slot="content" class="space-y-2 text-xs">
    <div>
      <div class="px-2 pb-1">Prompt</div>
      <TextareaInput readonly fullwidth bind:value={promptText} rows={8} />
    </div>
    {#if schema}
      <div>
        <div class="px-2 pb-1">Schema</div>
        <TextareaInput readonly fullwidth bind:value={schema} rows={8} />
      </div>
    {/if}
    <div>
      <div class="px-2 pb-1">Response</div>
      <TextareaInput readonly fullwidth bind:value={responseText} rows={8} />
    </div>
    {#if reasoning}
      <div>
        <div class="px-2 pb-1">Reasoning</div>
        <TextareaInput readonly fullwidth bind:value={reasoning} rows={5} />
      </div>
    {/if}
    <div>
      <div class="px-2 pb-1">Usage</div>
      <TextareaInput readonly fullwidth bind:value={usage} rows={5} />
    </div>
    <TextInput border readonly label="Duration" bind:value={duration_ms} postlabel="ms" />
    <TextInput border readonly label="Model" bind:value={model} />
    <TextInput border readonly label="Reasoning Level" bind:value={reasoningLevel} />
  </div>
</Modal>
